import { IsNumber, IsString, Length } from 'class-validator';

import { ItemTypeEnum } from '@onArte/shared/database';
import { AttachmentModel } from '@onArte/shared/models/common/attachments';
import { ItemAttributeModel } from '@onArte/shared/models/common/items';
import { ManufacturerModel, UpdateItemModel } from '@onArte/shared/models/website/items';

export class UpdateItemManagementModel extends UpdateItemModel {
  @IsString()
  @Length(32, 36)
  public ownerId: string;

  @IsString()
  @Length(0, 1000)
  public curatorialCommentary: string;

  @IsNumber({}, { each: true })
  public blogPostIds?: number[];

  constructor(
    type: ItemTypeEnum,
    categoryId: number,
    name: string,
    year: string,
    manufacturer: ManufacturerModel,
    locationId: string | null,
    attributes: ItemAttributeModel[],
    attachments: AttachmentModel[],
    description: string,
    ownerId: string,
    curatorialCommentary: string,
    blogPostIds: number[],
  ) {
    super(type, categoryId, name, year, manufacturer, locationId, attributes, attachments, description);
    this.ownerId = ownerId;
    this.description = description;
    this.curatorialCommentary = curatorialCommentary;
    this.blogPostIds = blogPostIds;
  }
}
